<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30 z-51"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span v-if="data.type == 4" class="PC_Body2-R text-[#FCFCFC]">
              ข้อมูลทรัพยากรที่ได้รับ
            </span>
            <span v-if="data.type == 6" class="PC_Body2-R text-[#FCFCFC]">
              ข้อมูลการโอนย้าย
            </span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>

          <div
            v-if="data.type == 4"
            class="flex flex-col p-[20px] gap-[16px] bg-[#FCFCFC]"
          >
            <div class="flex flex-col gap-[2px]">
              <div class="PC_Body2-R text-[#7C7379]">แหล่งที่มา</div>
              <div class="PC_Body1-R !text-[#1F1D1F]">
                {{
                  data.detail?.detail?.shelter_name
                    ? data.detail?.detail?.shelter_name
                    : data.detail?.detail?.other || "-"
                }}
              </div>
            </div>

            <div class="flex flex-col gap-[2px]">
              <div class="PC_Body2-R text-[#7C7379]">Lot no.</div>
              <div class="PC_Body1-R !text-[#1F1D1F]">
                {{ data.detail?.detail?.lot_no || "-" }}
              </div>
            </div>

            <div class="flex flex-col gap-[2px]">
              <div class="PC_Body2-R text-[#7C7379]">วันผลิต/วันหมดอายุ</div>
              <div class="PC_Body1-R !text-[#1F1D1F]">
                {{ $formatDate2(data.detail?.detail?.exp_date) || "-" }}
              </div>
            </div>

            <div class="flex flex-col gap-[2px]">
              <div class="PC_Body2-R text-[#7C7379]">หมายเหตุ</div>
              <div class="PC_Body1-R !text-[#1F1D1F]">
                {{ data.detail?.detail?.reason || "-" }}
              </div>
            </div>

            <!-- <div class="flex flex-col gap-[2px]">
              <div class="PC_Body2-R text-[#7C7379]">ผู้รับของ</div>
              <div class="PC_Body1-R !text-[#1F1D1F]">
                {{ data.detail?.detail?.recipient_name || "-" }}
              </div>
            </div> -->
          </div>

          <div
            v-if="data.type == 6"
            class="flex flex-col p-[20px] gap-[16px] bg-[#FCFCFC]"
          >
            <div class="flex flex-col gap-[2px]">
              <div class="PC_Body2-R text-[#7C7379]">ผู้โอน</div>
              <div class="PC_Body1-R !text-[#1F1D1F]">
                {{ data.detail.detail?.sender_name || "-" }}
              </div>
            </div>

            <div class="flex flex-col gap-[2px]">
              <div class="PC_Body2-R text-[#7C7379]">ผู้รับ</div>
              <div class="PC_Body1-R !text-[#1F1D1F]">
                {{ data.detail.detail?.recipient_name || "-" }}
              </div>
            </div>

            <div class="flex flex-col gap-[2px]">
              <div class="PC_Body2-R text-[#7C7379]">หมายเหตุ</div>
              <div class="PC_Body1-R !text-[#1F1D1F]">
                {{ data.detail.detail?.reason || "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const data = ref("");
const modalIsOpened = ref(false);

const emit = defineEmits(["status", "update"]);

const openModal = (item) => {
  console.log("item", item);

  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  data.value = item;
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

defineExpose({ openModal });
</script>
    
<style lang="scss" scoped>
@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>